/**************************************************
 * Nombre:       BotonGradiente
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import './boton.css'
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Datos from "../Dialogos/Dialogo_Datos";
import Dialogo_Datos_Cita from "../Dialogos/Dialogo_Datos_Cita";


const BotonGradienteCita = ({idLanding, cupos}) => {
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Datos_Cita,})


    return (
        <>
            <Dialogo/>

            <button
                onClick={() => abrir({idLanding: idLanding, cupos: cupos})}
                className={'bot'}
            >
                Agendarme
            </button>

        </>
    )

}
export default BotonGradienteCita